/* FullScreenSpaLoader.tsx generated by @compiled/babel-plugin v3.0.2 */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0jFU0VWP8C%7Bheight%3A100vh%7D%0A._1gBibygDor%7Banimation-name%3Aloading%7D%0A._0nFVCGFSlo%7Banimation-duration%3A2s%7D%0A._03m2nySHWH%7Banimation-iteration-count%3Ainfinite%7D");



import React from 'react';
import { cx } from '@atlaskit/css';
import { AtlassianIcon } from '@atlaskit/logo/atlassian-icon';
import { Box as CompiledBox } from '@atlaskit/primitives/compiled/box';
import { Inline as CompiledInline } from '@atlaskit/primitives/compiled/inline';
const compiledStyles = {
  spaLoader: "_0jFU0VWP8C",
  logo: "_1gBibygDor _0nFVCGFSlo _03m2nySHWH"
};
export const FullScreenSpaLoader = (): React.JSX.Element => <CompiledInline alignBlock="center" alignInline="center" grow="fill" xcss={cx(compiledStyles.spaLoader)} testId="full-screen-spa-loader">
		<CompiledBox xcss={cx(compiledStyles.logo)}>
			<AtlassianIcon appearance="brand" size="xlarge" />
		</CompiledBox>
	</CompiledInline>;